import { Props, useOtelLoadingSpanAndMetric } from './Loading/useOtelLoadingSpanAndMetric'
import { useOtelRenderMetric } from './useOtelRenderMetric'

/**
 * Convenience hook that instruments both loading latency and render counts for a component.
 * Equivalent to calling `useOtelLoadingSpanAndMetric` and `useOtelRenderMetric` together.
 *
 * IMPORTANT: inherits the singleton constraint of `useOtelLoadingSpanAndMetric` — do NOT use in components
 * that mount simultaneously. Use `useOtelLoadingMetric` + `useOtelRenderMetric` separately instead,
 * depending on the use case.
 *
 * @param name - A name, typically in the format of `Page.ComponentName` (e.g. OP.WeekView.Calendar), to provide context for the metrics and spans.
 * @param isLoading - A boolean indicating whether the component is currently loading data.
 * @param queryKey - A unique key used to track the query args.
 */
export function useOtelTracker({ name, isLoading, queryKey }: Props) {
    useOtelLoadingSpanAndMetric({ name, isLoading, queryKey })
    useOtelRenderMetric(name, isLoading)
}
